import { cn } from 'helpers/utils/classnames';
import * as React from 'react';
import { Input } from './input';
import { Button } from './button';
import EyeIcon from 'icons/eye-icon';

const PasswordInput = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    const [isShowPassword, setShowPassword] = React.useState<boolean>(false);
    return (
      <div className="relative w-full">
        <Input
          type={isShowPassword ? 'text' : 'password'}
          className={cn('rounded-[3px] border border-black/20 px-3 py-2 pr-10', className)}
          ref={ref}
          {...props}
        />
        <Button
          aria-label="View Password"
          type="button"
          className="absolute right-4 top-1/2 -translate-y-1/2"
          onClick={() => setShowPassword(!isShowPassword)}
        >
          <EyeIcon className={`${isShowPassword ? 'fill-[#4b5563]' : 'fill-[#7f7f7f]'} cursor-pointer text-lg`} />
        </Button>
      </div>
    );
  },
);
PasswordInput.displayName = 'Password Input';

export { PasswordInput };
